// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fcfafa;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(56, 1, 1, 0.1);
  height: 70px;
  transition: background-color 0.3s ease-in-out; /* Transition for background color */
  overflow: hidden;
}

.nav-logo {
  width: 150px;
  margin-left: 50px;
}

.nav-menu {
  list-style: none;
  display: flex;
  align-items: center;
}

.navbar-links {
  display: flex;
  align-items: center;
  font-size: x-large;
  margin-right: 50px;
}

.nav-links {
  text-decoration: none;
  color: #333;
  margin: 0 1rem;
  position: relative;
  transition: color 0.3s ease-in-out; /* Transition for link color */
}

.nav-links:hover {
  color: #0b54db;
 
}

.nav-cart-link {
  display: flex;
  align-items: center;
  position: relative;
}

.count-cart-item {
  position: absolute;
  top: -42px;
  right: -20px;
  color: #0b8f42;
  border-radius: 50%;
  padding: 6px;
  font-size: 24px;
}

.nav-cart-image {
  width: 30px;
  margin-left: 0.5rem;
}

/* Media query for responsive design */
@media screen and (max-width: 768px) {
  .nav-logo {
    display: none;
  }
  .navbar.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .nav-menu {
    flex-direction: column;
    margin-right: 60px;
  }

  .navbar-links {
    margin-right: 0;
    margin-bottom: 10px;
    font-size: small;
  }

  .nav-links {
    width: 100%;
    text-align: center;
    padding: 0rem;
    box-sizing: border-box;
  }

  .nav-cart-image {
    width: 20px;
    margin: 10px;
  }

  .count-cart-item {
    margin-right: 20px;
    font-size: 15px;
    margin-top: 36px;
  }
}

/* Additional styles for fixed navigation effect */
@media screen and (min-width: 769px) {
  .navbar.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/FrontEnd/Header/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,6CAA6C,EAAE,oCAAoC;EACnF,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,kCAAkC,EAAE,8BAA8B;AACpE;;AAEA;EACE,cAAc;;AAEhB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,wCAAwC;EAC1C;AACF","sourcesContent":[".navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fcfafa;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(56, 1, 1, 0.1);\n  height: 70px;\n  transition: background-color 0.3s ease-in-out; /* Transition for background color */\n  overflow: hidden;\n}\n\n.nav-logo {\n  width: 150px;\n  margin-left: 50px;\n}\n\n.nav-menu {\n  list-style: none;\n  display: flex;\n  align-items: center;\n}\n\n.navbar-links {\n  display: flex;\n  align-items: center;\n  font-size: x-large;\n  margin-right: 50px;\n}\n\n.nav-links {\n  text-decoration: none;\n  color: #333;\n  margin: 0 1rem;\n  position: relative;\n  transition: color 0.3s ease-in-out; /* Transition for link color */\n}\n\n.nav-links:hover {\n  color: #0b54db;\n \n}\n\n.nav-cart-link {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.count-cart-item {\n  position: absolute;\n  top: -42px;\n  right: -20px;\n  color: #0b8f42;\n  border-radius: 50%;\n  padding: 6px;\n  font-size: 24px;\n}\n\n.nav-cart-image {\n  width: 30px;\n  margin-left: 0.5rem;\n}\n\n/* Media query for responsive design */\n@media screen and (max-width: 768px) {\n  .nav-logo {\n    display: none;\n  }\n  .navbar.fixed {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background-color: #fff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .nav-menu {\n    flex-direction: column;\n    margin-right: 60px;\n  }\n\n  .navbar-links {\n    margin-right: 0;\n    margin-bottom: 10px;\n    font-size: small;\n  }\n\n  .nav-links {\n    width: 100%;\n    text-align: center;\n    padding: 0rem;\n    box-sizing: border-box;\n  }\n\n  .nav-cart-image {\n    width: 20px;\n    margin: 10px;\n  }\n\n  .count-cart-item {\n    margin-right: 20px;\n    font-size: 15px;\n    margin-top: 36px;\n  }\n}\n\n/* Additional styles for fixed navigation effect */\n@media screen and (min-width: 769px) {\n  .navbar.fixed {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background-color: #fff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
